import Resultbar from 'components/Resultbar'
import { itemmap } from 'data/items'
import styled from 'styled-components'
import WrongCountElement from '../WrongCountElement'
import { collectionsmap } from 'data/collections'
import { ChartFrame } from 'components/ChartFrame'
import { formatNumber } from 'components/Utils/formatNumber'

const ProductEvaluation = ({
  products,
  type = 'worst',
  hideFalse = false,
  participantsCount,
}: {
  products: DBItems
  type: 'worst' | 'best'
  hideFalse?: boolean
  participantsCount: number | undefined
}) => {
  const sortWorst = (a: [string, DBItem], b: [string, DBItem]) => {
    var total_a = a[1].correct + a[1].wrong
    var a_percent = (a[1].wrong * 100) / total_a
    var total_b = b[1].correct + b[1].wrong
    var b_percent = (b[1].wrong * 100) / total_b
    return b_percent - a_percent
  }

  const sortBest = (a: [string, DBItem], b: [string, DBItem]) => {
    var total_a = a[1].correct + a[1].wrong
    var a_percent = (a[1].wrong * 100) / total_a
    var total_b = b[1].correct + b[1].wrong
    var b_percent = (b[1].wrong * 100) / total_b
    return a_percent - b_percent
  }

  var products_to_show = (
    Object.entries(JSON.parse(JSON.stringify(products))) as [string, DBItem][]
  )
    .sort(type === 'worst' ? sortWorst : sortBest)
    .slice(0, 4)

  console.log(products_to_show)
  return (
    <ChartFrame
      lang='de'
      title={
        'Diese vier Produkte werden am häufigsten ' +
        (type === 'worst' ? 'falsch' : 'richtig') +
        ' zugeordnet'
      }
      lead={
        products_to_show.length > 0 &&
        products_to_show[0][0] &&
        itemmap[products_to_show[0][0]] && (
          <>
            {type == 'worst' && (
              <>
                <b>
                  {participantsCount} Leserinnen und Leser haben beim Quiz
                  mitgemacht.
                </b>{' '}
                Am häufigsten haben sie{' '}
                <b>{itemmap[products_to_show[0][0]].form_3_de}</b> falsch
                zugeordnet, {itemmap[products_to_show[0][0]].artikel_3_de}{' '}
                eigentlich{' '}
                {collectionsmap[itemmap[products_to_show[0][0]].correct[0]] &&
                  collectionsmap[itemmap[products_to_show[0][0]].correct[0]]
                    .correct_text_de}{' '}
                Stattdessen {itemmap[products_to_show[0][0]].form_4_de}{' '}
                {products_to_show[0][1].wrongAnswers &&
                  listItems(
                    Object.entries(products_to_show[0][1].wrongAnswers)
                      .sort((a, b) => b[1] - a[1])
                      .slice(0, 3)

                      .map((f) => collectionsmap[f[0]].form_2_de)
                      .filter((f) => f !== '')
                  )}
                .{' '}
              </>
            )}
            {type == 'best' && (
              <>
                Keine Probleme scheint den meisten die Entsorgung von{' '}
                <b>{itemmap[products_to_show[0][0]].form_2_de}</b> zu machen.{' '}
                {participantsCount && (
                  <>
                    <b>
                      {formatNumber(
                        (products_to_show[0][1].correct * 100) /
                          (products_to_show[0][1].correct +
                            products_to_show[0][1].wrong)
                        // participantsCount
                      )}{' '}
                      Prozent
                    </b>{' '}
                    der Teilnehmenden, die dieses Produkt zugeordnet haben,
                    warfen es in die richtige Sammlung.
                  </>
                )}
              </>
            )}
          </>
        )
      }
      colorKeyEntries={[
        { color: 'var(--correct-color)', label: 'richtig' },
        { color: 'var(--wrong-color)', label: 'falsch' },
      ]}
    >
      <ProductEvaluationContainer>
        {products_to_show.map(([itemid, item]) => {
          if (!itemmap[itemid] || !item) return null
          return (
            <SingleProduct
              item={item}
              itemdata={itemmap[itemid]}
              hideFalse={hideFalse}
            />
          )
        })}{' '}
      </ProductEvaluationContainer>
    </ChartFrame>
  )
}

const ProductEvaluationContainer = styled.div`
  display: flex;
  gap: 0px;
  flex-wrap: wrap;
`

export default ProductEvaluation

const SingleProduct = ({
  item,
  itemdata,
  hideFalse,
}: {
  item: DBItem
  itemdata: Item
  hideFalse?: boolean
}) => {
  let { correct, wrong, wrongAnswers } = item
  const total = correct + wrong
  if (!wrongAnswers) wrongAnswers = {}
  const wrongs = Object.entries(wrongAnswers)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 2)

  return (
    <SingleProductContainer>
      {/* <ImageCol>
        {itemdata.image && (
          <ItemImage
            src={require(`../../../images/Products/${itemdata.image}.png`)}
          />
        )}
        {!itemdata.image && <div style={{ width: '55px' }}></div>}
      </ImageCol> */}
      <RightCol>
        <HalfCol>
          <Title>{itemdata.name_de}</Title>
        </HalfCol>
        <HalfCol>
          <BarContainer>
            <Resultbar
              correct={(correct * 100) / total}
              tertiary
              hideValueLabels
            />
          </BarContainer>
        </HalfCol>

        <CorrectRow>
          <Label>Richtig:</Label>
          <List>
            {itemdata.correct.map((id) => {
              if (!collectionsmap[id]) return null
              return (
                <>
                  <WrongItem className='wrong'>
                    <Icon d={collectionsmap[id].icon} color='var(--gray-3)' />
                    <div style={{ color: 'var(--gray-3)' }}>
                      {collectionsmap[id].name_de}
                    </div>
                  </WrongItem>
                </>
              )
            })}
          </List>
        </CorrectRow>
        {!hideFalse && (
          <>
            <CorrectRow>
              <Label>Am häufigsten falsch:</Label>
              <List>
                {wrongs.map(([id, count]) => {
                  return (
                    <>
                      <WrongItem className='wrong'>
                        <Icon
                          d={collectionsmap[id].icon}
                          color='var(--gray-3)'
                        />
                        <div style={{ color: 'var(--gray-3)' }}>
                          {formatNumber((count * 100) / wrong)}%{' '}
                          {collectionsmap[id].name_de}
                        </div>
                      </WrongItem>
                    </>
                  )
                })}
              </List>
            </CorrectRow>
          </>
        )}
      </RightCol>
    </SingleProductContainer>
  )
}

const CorrectRow = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  align-items: center;
  line-height: 1.2em;
  letter-spacing: 0.2px;
`
const Label = styled.div`
  font-size: 13px;
  margin-right: 10px;
  color: var(--gray-3);

  @media screen and (max-width: 711px) {
    margin-top: 10px;
    font-size: 12px;
    flex: 0 0 100%;
  }
`
const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  * {
    margin-right: 10px;
  }
`

const RightCol = styled.div`
  flex: 0 0 calc(100% - 0px);
  display: flex;
  flex-wrap: wrap;
`

const BarContainer = styled.div`
  width: 100%;
`
const HalfCol = styled.div`
  flex: 0 0 calc(50%);
  display: flex;
  align-items: flex-start;

  @media screen and (max-width: 711px) {
    flex: 0 0 calc(100%);
    /* margin-bottom: 10px; */
  }
`
const FullCol = styled.div`
  flex: 0 0 calc(100%);
  /* padding-left: 55px; */
  display: flex;
  align-items: center;
  font-size: 12px;
`
const Icon = ({
  d,
  color = 'var(--beige-main)',
}: {
  d: string
  color?: string
}) => {
  return (
    <svg width={'18px'} height={'25px'} viewBox='0 0 40 40'>
      <path d={d} fill={color} />
    </svg>
  )
}
const WrongItem = styled.div`
  /* flex: 0 0 50%; */
  align-items: center;
  display: flex;
  line-height: 1.4em;
  svg {
    margin-right: 5px;
  }
  @media screen and (max-width: 711px) {
    flex: 0 0 calc(40%);
    white-space: nowrap;
    font-size: 13px;
  }
`
const Wrongs = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
const Column = styled.div`
  flex: 0 0 calc(50% - 0px);
  /* min-height: 120px; */
  display: flex;
  align-items: center;
  /* padding: 10px; */
  /* padding-right: 10px; */
`

const SingleProductContainer = styled.div`
  flex: 0 0 calc(100%);
  /* background-color: var(--beige-bright-2); */
  /* padding: 15px; */
  /* border-radius: 15px; */

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--beige-bright-1);

  margin-bottom: 15px;
  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }
`

const Title = styled.div`
  font-size: 19px;
  font-weight: 700;
  margin-top: 4px;
  &::first-letter {
    text-transform: uppercase;
  }
  @media screen and (max-width: 711px) {
    font-size: 17px;
  }
`

function listItems(items: (string | undefined)[]) {
  var list = items?.map(
    (item, i) =>
      item +
      (i === items.length - 2 ? ' oder ' : i === items.length - 1 ? '' : ', ')
  )
  return list?.join('')
}
